import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  UPDATE_PROFILE_REQUEST: '',
  UPDATE_PROFILE_SUCCESS: '',
  UPDATE_PROFILE_FAILURE: '',
};

types = setStoreTypeValues(types, 'appUserProfile');

export default types;
